module.exports = __webpack_public_path__ + "img/homepage.3ba573d.jpg";